// Generated by ReScript, PLEASE EDIT WITH CARE

import AnomalyImgTsx from "./AnomalyImg.tsx";

var make = AnomalyImgTsx;

export {
  make ,
  
}
/* make Not a pure module */
